<template>
  <!-- <pdf v-if="returnData" :page="1" class="pdf-component" :src="returnData" /> -->
  <div class="top_box">
    <div class="big_title">组织架构</div>
    <img v-if="returnData" class="pdf-component" :src="returnData" alt="" />
  </div>
</template>
<script setup>
// import pdf from "vue-pdf";
import api from "@/api/api";
import { ref } from "vue";
let returnData = ref("");
const getBanner = async () => {
  let res = await api.getPageConfigDetail(81);
  if (res.code === "0") {
    returnData.value = res.res.data.thumbUrl;
    // console.log()
  }
};
getBanner();
</script>
<style lang="less" scoped>
.pdf-component {
  width: 100%; // 调整PDF页面的宽度以适应内容
  height: auto; // 调整PDF页面的高度以适应内容
}
.big_title {
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #333333;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
}
</style>